// extracted by mini-css-extract-plugin
export var subtitle = "_cx-2";
export var title = "_cx-0";
export var titleNoWrap = "_cx-1";